module.exports = __webpack_public_path__ + "static/16-HiSilicon-dde96dbbb8ff15c5ae09fddac31a591f.png";